import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AlertMessage } from "../../alert-message/AlertMessage";
import { Input } from "../Input";
import {
  Props,
  getPasswordErrorMessage,
  text,
} from "./NewPasswordInputs.Parts";
import { PasswordRules } from "./password-rules/PasswordRules";

export const NewPasswordInputs = ({
  passwordLabel = text.label,
  confirmPasswordLabel = text.confirmPassword.label,
}: Props) => {
  const {
    trigger,
    formState: { errors, dirtyFields, touchedFields },
  } = useFormContext();

  useEffect(() => {
    void trigger(text.newPassword.id);
  }, [trigger]);

  return (
    <>
      <Input
        type="password"
        id={text.newPassword.id}
        label={passwordLabel}
        registerOptions={{
          onChange: () => {
            void trigger(text.newPassword.id);
            if (touchedFields[text.confirmPassword.id])
              void trigger(text.confirmPassword.id);
          },
        }}
        errorMessage={getPasswordErrorMessage(errors[text.newPassword.id])}
      />
      <Input
        type="password"
        id={text.confirmPassword.id}
        label={confirmPasswordLabel}
      />
      {dirtyFields[text.newPassword.id] && !errors[text.newPassword.id] ? (
        <AlertMessage isFormValid={true} successMessage={text.success} />
      ) : (
        <PasswordRules passwordError={errors[text.newPassword.id]} />
      )}
    </>
  );
};
